import SettingsIcon from "@mui/icons-material/Settings";
import StaffSettingsPage from "./StaffSettingsPage";

export default {
  list: StaffSettingsPage,
  icon: SettingsIcon,
  label: "Staff settings",
  options: { label: "Staff settings" },
  name: "staffSettings",
};
